import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[locale]/(client)/(clients-page)/layout.jsx");
